import { render } from "./Config.vue?vue&type=template&id=04220052&scoped=true&ts=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=04220052&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04220052"]])

export default __exports__